module.exports = __webpack_public_path__ + "static/media/bg1.070fea19.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/bg1.png
// module id = 364
// module chunks = 0